"use client";
import { useEffect } from "react";

import { SHOW_COOKIE_PREFERENCES_MODAL_QUERY_PARAM } from "./constants";
import { useSearchParams } from "next/navigation";

export default function CookiePreferencesModal() {
  const showCookiePreferencesModal = useSearchParams()?.get(
    SHOW_COOKIE_PREFERENCES_MODAL_QUERY_PARAM
  );

  useEffect(() => {
    setTimeout(() => {
      if (
        typeof window !== "undefined" &&
        showCookiePreferencesModal === "true" &&
        !!window.OneTrust
      ) {
        window.OneTrust?.ToggleInfoDisplay();
      }
    }, 1000);
  }, [showCookiePreferencesModal]);

  return null;
}
